var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-5 is-offset-4"},[_c('div',{staticClass:"notification is-danger"},[_vm._t("body",[_vm._v("Mensaje de Error, mostrado ...")])],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }